export const isValidCollecitonAddress = (address: string) => {
  return address?.length === 42 && address.startsWith('0x');
};

export const isValidCollecitonAddressOrEmpty = (address?: string) => {
  return !address || isValidCollecitonAddress(address);
};
